module.exports = __webpack_public_path__ + "img/icon_agent_hk.616b27d9.png";